import { render } from "./MypagePartnerInfo.vue?vue&type=template&id=7900b237&scoped=true"
import script from "./MypagePartnerInfo.vue?vue&type=script&lang=js"
export * from "./MypagePartnerInfo.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_profile.css?vue&type=style&index=0&id=7900b237&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7900b237"]])

export default __exports__